import { useMutation } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
interface PublishStandardsSetProps {
  standardsSetId: string;
}

export const usePublishStandardsSet = () => {
  return useMutation<void, Error, PublishStandardsSetProps>({
    mutationFn: async ({
      standardsSetId,
    }: PublishStandardsSetProps): Promise<void> => {
      await api().post<void>(
        `${ApiCatalog.draftContent.endpoint}${standardsSetId}/publication/`,
        {},
      );
    },
  });
};
